"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const SimpleButton_1 = require("../../atoms/SimpleButton/SimpleButton");
const styled_1 = __importDefault(require("@emotion/styled"));
const colors_1 = require("../../../styles/colors");
const Typo_1 = require("../../atoms/Typo/Typo");
const MobileStepperContainer = (0, styled_1.default)(material_1.MobileStepper) `
  background-color: transparent;
  min-width: 485px;
`;
const StepperContainer = (0, styled_1.default)(material_1.Stepper) `
  min-width: ${({ orientation }) => (orientation !== 'vertical' ? '500px' : '')};
  max-width: ${({ orientation }) => (orientation !== 'vertical' ? '' : '500px')};
`;
const StyledStepLabel = (0, styled_1.default)(material_1.StepLabel) `
  .Mui-completed {
    .MuiStepIcon-root {
      color: ${({ icon }) => (icon === ' ' ? colors_1.$green : colors_1.$primaryBrand)};
    }
  }
  .Mui-disabled {
    .MuiSvgIcon-root {
      color: ${({ icon }) => (icon === ' ' ? colors_1.$primaryWhite : colors_1.$primaryNavy)};
      border: ${({ icon }) => (icon === ' ' ? '1px solid #000' : 'none')};
      border-radius: ${({ icon }) => (icon === ' ' ? '50%' : 'none')};
      ${({ icon }) => (icon === ' ' ? 'height: 22px; width: 22px' : '')};
    }
  }
  .MuiStepLabel-label {
    font-weight: 300;
    color: ${colors_1.$primaryBlack};
    &.Mui-active {
      font-weight: 300;
      color: ${({ icon }) => (icon === ' ' ? colors_1.$primaryBrand : '')};
    }
    &.Mui-completed {
      font-weight: 300;
    }
  }
  .MuiStepLabel-iconContainer {
    .Mui-completed {
      color: ${({ icon }) => (icon === ' ' ? colors_1.$green : colors_1.$primaryBrand)};
    }
    .Mui-active {
      color: ${colors_1.$primaryBrand};
    }
  }
`;
const StyledConnector = (0, styled_1.default)(material_1.StepConnector)(() => ({
    [`&.${material_1.stepConnectorClasses.active}`]: {
        [`& .${material_1.stepConnectorClasses.line}`]: {
            borderTop: '1px solid #999',
        },
    },
    [`&.${material_1.stepConnectorClasses.disabled}`]: {
        [`& .${material_1.stepConnectorClasses.line}`]: {
            border: '1px dashed #999',
        },
    },
}));
const ButtonsContainer = styled_1.default.div `
  display: flex;
  gap: 16px;
  margin-top: 32px;
`;
const Stepper = (_a) => {
    var _b, _c;
    var { isPagination, buttonColor } = _a, rest = __rest(_a, ["isPagination", "buttonColor"]);
    const [activeStep, setActiveStep] = react_1.default.useState(rest.activeStep | 0);
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const stepper = rest.orientation !== 'vertical' ? ((0, jsx_runtime_1.jsx)(StepperContainer, Object.assign({ "data-testid": rest.isInformativeStatus ? 'informative-status-stepper' : 'timeline-stepper', alternativeLabel: true, activeStep: activeStep, connector: (0, jsx_runtime_1.jsx)(StyledConnector, {}), orientation: rest.orientation }, { children: (_b = rest.states) === null || _b === void 0 ? void 0 : _b.map((state, index) => ((0, jsx_runtime_1.jsx)(material_1.Step, { children: (0, jsx_runtime_1.jsx)(StyledStepLabel, Object.assign({ icon: rest.isInformativeStatus ? ' ' : '', StepIconProps: { completed: false }, optional: state.subtitle && !state.component ? ((0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ fontWeight: 300, color: colors_1.$grey40, variant: "caption" }, { children: state.subtitle }))) : null }, { children: state.component || state.title })) }, index))) }))) : ((0, jsx_runtime_1.jsx)(StepperContainer, Object.assign({ activeStep: activeStep, orientation: rest.orientation, "data-testid": "vertical-stepper" }, { children: (_c = rest.states) === null || _c === void 0 ? void 0 : _c.map((state, index) => ((0, jsx_runtime_1.jsxs)(material_1.Step, { children: [(0, jsx_runtime_1.jsx)(StyledStepLabel, Object.assign({ icon: rest.isInformativeStatus ? ' ' : '' }, { children: state.title })), (0, jsx_runtime_1.jsxs)(material_1.StepContent, { children: [state.component || (0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ variant: "subtitle1" }, { children: state.description })), (0, jsx_runtime_1.jsxs)(ButtonsContainer, { children: [(0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, Object.assign({ "data-testid": "back-button", variant: "outlined", size: "small", disabled: index === 0, onClick: handleBack }, { children: "Back" })), (0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, Object.assign({ "data-testid": "next-button", variant: "text", size: "small", onClick: handleNext }, { children: "Next" }))] })] })] }, index))) })));
    return isPagination ? ((0, jsx_runtime_1.jsx)(MobileStepperContainer, Object.assign({}, rest, { steps: rest.steps || 0, "data-testid": "pagination-stepper", position: "static", color: rest.color, variant: rest.type, activeStep: activeStep, backButton: (0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, Object.assign({ "data-testid": "previous-button", color: "success", textUppercase: true, variant: `no-background-${buttonColor}`, startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.KeyboardArrowLeft, { htmlColor: activeStep === 0 ? colors_1.$grey10 : colors_1.$primaryBlack }), size: "small", onClick: handleBack, disabled: activeStep === 0 }, { children: "Previous" })), nextButton: (0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, Object.assign({ "data-testid": "next-button", color: "success", variant: `no-background-${buttonColor}`, textUppercase: true, endIcon: (0, jsx_runtime_1.jsx)(icons_material_1.KeyboardArrowRight, { htmlColor: activeStep === rest.steps - 1 ? colors_1.$grey10 : colors_1.$primaryBlack }), size: "small", onClick: handleNext, disabled: activeStep === rest.steps - 1 }, { children: "Next" })) }))) : (stepper);
};
exports.Stepper = Stepper;
